import PreTable from './PreTable';
import ContentTable from './ContentTable';


const B2BTable = ({
    clientData,
    handleClickAddB2B,
    isLoadingSubmit,
    portalInfoData,
    handleChangePortal,
    handleChangePortalLink,
    isErrorB2BAddRequest,
    removeLastB2BRowTable,
    isClickedAddB2BManual,
    showModal,
    setShowModal,
    handleChangeUserTypeWalmart,
    isGS1 = false,
}) => {
    return (
        <div className="row">
            <div className="col-12">
                <PreTable />
                <br />
                <ContentTable
                    b2bTable={(clientData.b2b_table || []).length > 0 ? clientData.b2b_table : [{}]}
                    handleClickAddB2B={handleClickAddB2B}
                    isLoading={isLoadingSubmit}
                    portalInfoData={portalInfoData}
                    handleChangePortal={handleChangePortal}
                    handleChangePortalLink={handleChangePortalLink}
                    isErrorB2BAddRequest={isErrorB2BAddRequest}
                    removeLastB2BRowTable={removeLastB2BRowTable}
                    isClickedAddB2BManual={isClickedAddB2BManual}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    handleChangeUserTypeWalmart={handleChangeUserTypeWalmart}
                    isGS1={isGS1}
                />
            </div>
        </div>
    );
};

export default B2BTable;
